import { request } from "services/request";

const resource = "api/OrganizationPartners";

const list = () => request(`${resource}/getList`, { method: "GET" });

export { list };
